import type { WhitelistEntry } from '../types';
import AutocompleteInput from './AutocompleteInput';

interface WhitelistTabProps {
  entries: WhitelistEntry[];
  availableOptions: { id: string; name: string }[];
  onAdd: (id: string) => void;
  onRemove: (id: string) => void;
  isLoading?: boolean;
  placeholder: string;
}

export default function WhitelistTab({
  entries,
  availableOptions,
  onAdd,
  onRemove,
  isLoading = false,
  placeholder,
}: WhitelistTabProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          항목 추가
        </label>
        <AutocompleteInput
          options={availableOptions}
          onSelect={onAdd}
          placeholder={placeholder}
          isLoading={isLoading}
        />
      </div>

      <div>
        <h3 className="text-sm font-medium text-gray-700 mb-2">
          화이트리스트 항목 ({entries.length})
        </h3>
        {entries.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            화이트리스트에 추가된 항목이 없습니다
          </div>
        ) : (
          <div className="space-y-2">
            {entries.map((entry) => (
              <div
                key={entry.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div>
                  <p className="font-medium text-gray-900">{entry.name}</p>
                  <p className="text-sm text-gray-500">{entry.id}</p>
                </div>
                <button
                  onClick={() => onRemove(entry.id)}
                  disabled={isLoading}
                  className="text-red-600 hover:text-red-900 disabled:opacity-50"
                >
                  삭제
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
